import { render } from "./CliConfirmationTab.vue?vue&type=template&id=5e1766c5&scoped=true&ts=true"
import script from "./CliConfirmationTab.vue?vue&type=script&lang=ts"
export * from "./CliConfirmationTab.vue?vue&type=script&lang=ts"

import "./CliConfirmationTab.vue?vue&type=style&index=0&id=5e1766c5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1766c5"]])

export default __exports__